import React from 'react';

import {getDateRange} from '@unthinkable/react-date-picker/src/DateUtility';
import {getZeroTimeDate} from '@unthinkable/react-filters';
import {
  GroupFilter,
  PeriodRangeFilter,
  SearchFilter,
} from '../../../components/filter/Filters';
import {TabView} from '../../../components/tab/TabView';
import {useFilter} from '../../../controllers/useFilter';
import {
  ClosedPromotionByPH,
  ClosedPromotionHR,
  ClosedPromotionsManager,
  HRFinalPromotedEmployees,
  PendingByPhPromotionsHr,
  PendingPromotionsHr,
  PendingPromotionsManager,
  PendingPromotionsPH,
  SelfPromotionView,
} from './PromotionRecommendationLists';
import {AddButton} from '../../../components/button/AddButton';

const getCurrentFY = () => {
  let {from, to} = getDateRange('currentFinancialYear');
  from = getZeroTimeDate(from);
  to = getZeroTimeDate(to, true);
  return {
    from,
    to,
    filterOf: 'FY',
  };
};

export const PromotionRecommendationPrimaryReportingTabs = props => {
  let {route: {params} = {}} = props;
  const {applyFilter, onChangeFilter, searchValue, filterValues} = useFilter({
    params: {
      period: getCurrentFY(),
    },
  });
  const {filter, params: filterParams = {}} = filterValues;
  const {organization, product, period, ...rest} = params;
  params = {
    ...filterParams,
    ...rest,
    product,
    organization,
  };

  let tabs = {};
  tabs.pending = {
    label: 'Due',
    params: {
      ...params,
    },
    limit: 5000,
    eventSourceId: 'Promotion',
    view: (
      <PendingPromotionsManager
        {...props}
        search={searchValue}
        addOnFilter={filter}
        filterParams={filterParams}
        params={params}
      />
    ),
    actions: [
      <SearchFilter
        value={searchValue}
        onChangeFilter={onChangeFilter}
        placeholder="Search"
      />,
      <GroupFilter
        filterValues={filterValues}
        applyFilter={applyFilter}
        filters={[
          {
            type: 'autoComplete',
            label: 'Employee',
            api: '/employeeSuggestions',
            placeholder: 'Select',
            suggestionField: 'name',
            secondarySuggestionField: 'official_email_id',
            valueField: 'name',
            field: 'employee',
            searchFields: ['name', 'official_email_id', 'employee_code'],
          },
        ]}
      />,
    ],
  };

  tabs.closed = {
    label: 'Closed',
    params: {
      ...params,
    },
    // addOnFilter: filter,
    limit: 5000,
    eventSourceId: 'Promotion',
    view: (
      <ClosedPromotionsManager
        {...props}
        search={searchValue}
        addOnFilter={filter}
        filterParams={filterParams}
        params={params}
      />
    ),
    actions: [
      <PeriodRangeFilter
        onChangeFilter={onChangeFilter}
        filterValues={filterValues}
        asParam
      />,
      <GroupFilter
        filterValues={filterValues}
        applyFilter={applyFilter}
        filters={[
          <PeriodRangeFilter
            onChangeFilter={onChangeFilter}
            filterValues={filterValues}
            asParam
          />,
          {
            type: 'autoComplete',
            label: 'Employee',
            api: '/employeeSuggestions',
            placeholder: 'Select',
            suggestionField: 'name',
            secondarySuggestionField: 'official_email_id',
            valueField: 'name',
            field: 'employee',
          },
        ]}
      />,
    ],
  };
  return (
    <TabView
      tabs={tabs}
      {...props}
      // actions={[
      //   <SearchFilter
      //     value={searchValue}
      //     onChangeFilter={onChangeFilter}
      //     placeholder="Search"
      //   />,
      //   <PeriodRangeFilter
      //     onChangeFilter={onChangeFilter}
      //     filterValues={filterValues}
      //     asParam
      //   />,
      //   <GroupFilter
      //     filterValues={filterValues}
      //     applyFilter={applyFilter}
      //     filters={[
      //       // {
      //       //   type: 'date',
      //       //   field: 'resign_date_new',
      //       //   label: 'Resign Date',
      //       // },
      //       {
      //         type: 'autoComplete',
      //         placeholder: 'Select',
      //         options: [
      //           {label: 'Regrettable', value: 'Regrettable'},
      //           {label: 'Desirable', value: 'Desirable'},
      //         ],
      //         field: 'desireable_status',
      //         label: 'Desireable Status',
      //         suggestionField: 'label',
      //         keyField: 'value',
      //         valueField: 'label',
      //       },
      //       {
      //         type: 'autoComplete',
      //         field: 'exit_type',
      //         label: 'Type',
      //         options: ['Involuntary', 'Voluntary'],
      //       },
      //     ]}
      //   />,
      // ]}
    />
  );
};

export const PromotionRecommendationPHTabs = props => {
  let {route: {params} = {}} = props;
  const {applyFilter, onChangeFilter, searchValue, filterValues} = useFilter({
    params: {
      period: getCurrentFY(),
    },
  });
  const {filter, params: filterParams = {}} = filterValues;
  const {organization, product, period, ...rest} = params;
  params = {
    ...filterParams,
    ...rest,
    product,
    organization,
  };

  let tabs = {};
  tabs.pending = {
    label: 'Due',
    params: {
      ...params,
    },
    limit: 5000,
    eventSourceId: 'Promotion',
    view: (
      <PendingPromotionsPH
        {...props}
        search={searchValue}
        addOnFilter={filter}
        filterParams={filterParams}
        params={params}
      />
    ),
    actions: [
      <SearchFilter
        value={searchValue}
        onChangeFilter={onChangeFilter}
        placeholder="Search"
      />,
      <GroupFilter
        filterValues={filterValues}
        applyFilter={applyFilter}
        filters={[
          {
            type: 'autoComplete',
            label: 'Employee',
            api: '/employeeSuggestions',
            placeholder: 'Select',
            suggestionField: 'name',
            secondarySuggestionField: 'official_email_id',
            valueField: 'name',
            field: 'employee',
            searchFields: ['name', 'official_email_id', 'employee_code'],
          },
        ]}
      />,
    ],
  };

  tabs.closed = {
    label: 'Closed',
    params: {
      ...params,
    },
    // addOnFilter: filter,
    limit: 5000,
    eventSourceId: 'Probation',
    view: (
      <ClosedPromotionByPH
        {...props}
        search={searchValue}
        addOnFilter={filter}
        filterParams={filterParams}
        params={params}
      />
    ),
    actions: [
      <PeriodRangeFilter
        onChangeFilter={onChangeFilter}
        filterValues={filterValues}
        asParam
      />,
      <GroupFilter
        filterValues={filterValues}
        applyFilter={applyFilter}
        filters={[
          <PeriodRangeFilter
            onChangeFilter={onChangeFilter}
            filterValues={filterValues}
            asParam
          />,
          {
            type: 'autoComplete',
            label: 'Employee',
            api: '/employeeSuggestions',
            placeholder: 'Select',
            suggestionField: 'name',
            secondarySuggestionField: 'official_email_id',
            valueField: 'name',
            field: 'employee',
          },
        ]}
      />,
    ],
  };
  return (
    <TabView
      tabs={tabs}
      {...props}
      // actions={[
      //   <SearchFilter
      //     value={searchValue}
      //     onChangeFilter={onChangeFilter}
      //     placeholder="Search"
      //   />,
      //   <PeriodRangeFilter
      //     onChangeFilter={onChangeFilter}
      //     filterValues={filterValues}
      //     asParam
      //   />,
      //   <GroupFilter
      //     filterValues={filterValues}
      //     applyFilter={applyFilter}
      //     filters={[
      //       // {
      //       //   type: 'date',
      //       //   field: 'resign_date_new',
      //       //   label: 'Resign Date',
      //       // },
      //       {
      //         type: 'autoComplete',
      //         placeholder: 'Select',
      //         options: [
      //           {label: 'Regrettable', value: 'Regrettable'},
      //           {label: 'Desirable', value: 'Desirable'},
      //         ],
      //         field: 'desireable_status',
      //         label: 'Desireable Status',
      //         suggestionField: 'label',
      //         keyField: 'value',
      //         valueField: 'label',
      //       },
      //       {
      //         type: 'autoComplete',
      //         field: 'exit_type',
      //         label: 'Type',
      //         options: ['Involuntary', 'Voluntary'],
      //       },
      //     ]}
      //   />,
      // ]}
    />
  );
};

export const PromotionRecommendationHRTabs = props => {
  let {route: {params} = {}} = props;
  const {applyFilter, onChangeFilter, searchValue, filterValues} = useFilter({
    params: {
      period: getCurrentFY(),
    },
  });
  const {filter, params: filterParams = {}} = filterValues;
  const {organization, product, period, ...rest} = params;
  params = {
    ...filterParams,
    ...rest,
    product,
    organization,
  };

  let tabs = {};
  tabs.pending = {
    label: 'Due',
    params: {
      ...params,
    },
    limit: 5000,
    eventSourceId: 'Promotion',
    view: (
      <PendingPromotionsHr
        {...props}
        search={searchValue}
        addOnFilter={filter}
        filterParams={filterParams}
        params={params}
      />
    ),
    actions: [
      <SearchFilter
        value={searchValue}
        onChangeFilter={onChangeFilter}
        placeholder="Search"
      />,
      <GroupFilter
        filterValues={filterValues}
        applyFilter={applyFilter}
        filters={[
          {
            type: 'autoComplete',
            label: 'Employee',
            api: '/employeeSuggestions',
            placeholder: 'Select',
            suggestionField: 'name',
            secondarySuggestionField: 'official_email_id',
            valueField: 'name',
            field: 'employee',
            searchFields: ['name', 'official_email_id', 'employee_code'],
          },
        ]}
      />,
      <AddButton
        title="Promotion"
        view="add-promotion-employee"
        params={props?.route?.params}
      />,
    ],
  };

  tabs.pending_by_ph = {
    label: 'Pending by PH',
    params: {
      ...params,
    },
    // addOnFilter: filter,
    limit: 5000,
    eventSourceId: 'Promotion',
    view: (
      <PendingByPhPromotionsHr
        {...props}
        search={searchValue}
        addOnFilter={filter}
        filterParams={filterParams}
        params={params}
      />
    ),
    actions: [
      <PeriodRangeFilter
        onChangeFilter={onChangeFilter}
        filterValues={filterValues}
        asParam
      />,
      <GroupFilter
        filterValues={filterValues}
        applyFilter={applyFilter}
        filters={[
          <PeriodRangeFilter
            onChangeFilter={onChangeFilter}
            filterValues={filterValues}
            asParam
          />,
          {
            type: 'autoComplete',
            label: 'Employee',
            api: '/employeeSuggestions',
            placeholder: 'Select',
            suggestionField: 'name',
            secondarySuggestionField: 'official_email_id',
            valueField: 'name',
            field: 'employee',
          },
        ]}
      />,
    ],
  };

  tabs.closed_promotions = {
    label: 'Closed',
    params: {
      ...params,
    },
    // addOnFilter: filter,
    limit: 5000,
    eventSourceId: 'Promotion',
    view: (
      <ClosedPromotionHR
        {...props}
        search={searchValue}
        addOnFilter={filter}
        filterParams={filterParams}
        params={params}
      />
    ),
    actions: [
      <PeriodRangeFilter
        onChangeFilter={onChangeFilter}
        filterValues={filterValues}
        asParam
      />,
      <GroupFilter
        filterValues={filterValues}
        applyFilter={applyFilter}
        filters={[
          <PeriodRangeFilter
            onChangeFilter={onChangeFilter}
            filterValues={filterValues}
            asParam
          />,
          {
            type: 'autoComplete',
            label: 'Employee',
            api: '/employeeSuggestions',
            placeholder: 'Select',
            suggestionField: 'name',
            secondarySuggestionField: 'official_email_id',
            valueField: 'name',
            field: 'employee',
          },
        ]}
      />,
    ],
  };

  tabs.promoted = {
    label: 'Promoted',
    params: {
      ...params,
    },
    // addOnFilter: filter,
    limit: 5000,
    eventSourceId: 'Promotion',
    view: (
      <HRFinalPromotedEmployees
        {...props}
        search={searchValue}
        addOnFilter={filter}
        filterParams={filterParams}
        params={params}
      />
    ),
    actions: [
      <GroupFilter
        filterValues={filterValues}
        applyFilter={applyFilter}
        filters={[
          <PeriodRangeFilter
            onChangeFilter={onChangeFilter}
            filterValues={filterValues}
            asParam
          />,
          {
            type: 'autoComplete',
            label: 'Employee',
            api: '/employeeSuggestions',
            placeholder: 'Select',
            suggestionField: 'name',
            secondarySuggestionField: 'official_email_id',
            valueField: 'name',
            field: 'employee',
          },
        ]}
      />,
    ],
  };
  return (
    <TabView
      tabs={tabs}
      {...props}
      // actions={[
      //   <SearchFilter
      //     value={searchValue}
      //     onChangeFilter={onChangeFilter}
      //     placeholder="Search"
      //   />,
      //   <PeriodRangeFilter
      //     onChangeFilter={onChangeFilter}
      //     filterValues={filterValues}
      //     asParam
      //   />,
      //   <GroupFilter
      //     filterValues={filterValues}
      //     applyFilter={applyFilter}
      //     filters={[
      //       // {
      //       //   type: 'date',
      //       //   field: 'resign_date_new',
      //       //   label: 'Resign Date',
      //       // },
      //       {
      //         type: 'autoComplete',
      //         placeholder: 'Select',
      //         options: [
      //           {label: 'Regrettable', value: 'Regrettable'},
      //           {label: 'Desirable', value: 'Desirable'},
      //         ],
      //         field: 'desireable_status',
      //         label: 'Desireable Status',
      //         suggestionField: 'label',
      //         keyField: 'value',
      //         valueField: 'label',
      //       },
      //       {
      //         type: 'autoComplete',
      //         field: 'exit_type',
      //         label: 'Type',
      //         options: ['Involuntary', 'Voluntary'],
      //       },
      //     ]}
      //   />,
      // ]}
    />
  );
};

export const SelfPromotionViewTabs = props => {
  let {route: {params} = {}} = props;
  const {applyFilter, onChangeFilter, searchValue, filterValues} = useFilter({
    params: {
      period: getCurrentFY(),
    },
  });
  const {filter, params: filterParams = {}} = filterValues;
  const {organization, product, period, ...rest} = params;
  params = {
    ...filterParams,
    ...rest,
    product,
    organization,
  };

  let tabs = {};
  tabs.promotions = {
    label: 'Promotions',
    params: {
      ...params,
    },
    limit: 5000,
    eventSourceId: 'Promotion',
    view: (
      <SelfPromotionView
        {...props}
        search={searchValue}
        addOnFilter={filter}
        filterParams={filterParams}
        params={params}
      />
    ),
    actions: [
      <SearchFilter
        value={searchValue}
        onChangeFilter={onChangeFilter}
        placeholder="Search"
      />,
    ],
  };

  return (
    <TabView
      tabs={tabs}
      {...props}
      // actions={[
      //   <SearchFilter
      //     value={searchValue}
      //     onChangeFilter={onChangeFilter}
      //     placeholder="Search"
      //   />,
      //   <PeriodRangeFilter
      //     onChangeFilter={onChangeFilter}
      //     filterValues={filterValues}
      //     asParam
      //   />,
      //   <GroupFilter
      //     filterValues={filterValues}
      //     applyFilter={applyFilter}
      //     filters={[
      //       // {
      //       //   type: 'date',
      //       //   field: 'resign_date_new',
      //       //   label: 'Resign Date',
      //       // },
      //       {
      //         type: 'autoComplete',
      //         placeholder: 'Select',
      //         options: [
      //           {label: 'Regrettable', value: 'Regrettable'},
      //           {label: 'Desirable', value: 'Desirable'},
      //         ],
      //         field: 'desireable_status',
      //         label: 'Desireable Status',
      //         suggestionField: 'label',
      //         keyField: 'value',
      //         valueField: 'label',
      //       },
      //       {
      //         type: 'autoComplete',
      //         field: 'exit_type',
      //         label: 'Type',
      //         options: ['Involuntary', 'Voluntary'],
      //       },
      //     ]}
      //   />,
      // ]}
    />
  );
};
